function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3312"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3019",
  d: "M5.287 151.779c-.858-.406.469-19.512.592-24.859.151-6.59.587-50.116 1.943-55.782.976-4.075 3.563-21.789 6.365-21.846 11.486-.237 273.437-4.7 275.777 1.284 1.086 2.78 2.88 10.772 4.617 20.352.55 3.034 2.7 46.448 2.122 55.912-.205 3.38 1.532 25 .1 25.131-18.058 1.598-287.933 1.504-291.516-.192z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3303"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 688",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M119.521 159.417h65.18v25.489h-65.18z"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3020",
  d: "M21.285 49.223c-1.378 8.106-.018 4.923-.124 13.019s.754 89.718.754 89.718",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3304"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3021",
  d: "M281.396 49.482c1.378 8.105.018 4.923.124 13.019s-.754 89.718-.754 89.718",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3305"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3022",
  d: "M167.381 72.45a3.665 3.665 0 00-3.664-3.663h-24.912a3.665 3.665 0 00-3.664 3.663v7.326a3.665 3.665 0 003.664 3.662h24.912a3.665 3.665 0 003.664-3.662z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 689",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M138.903 70.592h25.105v5.09h-25.105z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3023",
  d: "M281.661 70.179c4.491-.068 12.864-.846 12.97 1.45",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3024",
  d: "M281.128 126.598c4.691.062 14.936 1.1 15.588-1.452",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3025",
  d: "M20.996 70.24c-5.559-.085-12.667-.147-13.32 1.8",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3026",
  d: "M21.592 126.619c-5.27.1-15.322.245-15.5-1.469",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3027",
  d: "M1.561 164.742c.526-1.045 84.017-2.314 85.24.387.873 1.928 5.719 31.694 4 32.376-4.144 1.645-35.353.641-37.115-.533-1.3-.864-3.849-7.189-4.681-7.739s-39.512.821-40.729-.821c-4.268-5.758-8.818-19.486-6.715-23.67z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3306"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3028",
  d: "M302.493 162.969c-.526-1.045-84.016-2.314-85.24.388-.873 1.927-5.718 31.694-4 32.376 4.144 1.646 35.353.641 37.115-.532 1.3-.864 3.849-7.189 4.681-7.739s39.512.82 40.729-.821c4.268-5.763 8.819-19.494 6.715-23.672z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3029",
  d: "M6.521 151.947c-3.782-.113-5.53 3.032-4.925 12.934",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3030",
  d: "M296.588 152c4.5.915 5.785 4.085 5.175 10.583",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3031",
  d: "M90.995 197.347c14.407-.16 115.825-.757 121.932-1.792",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3032",
  d: "M115.287 197.169c12.377-.225 15.78 16.328 37.717 15.688 21.793-.634 22.8-16.831 36.267-16.534",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3307"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3033",
  d: "M158.605 201.337a2.888 2.888 0 00-2.887-2.886h-7.075a2.888 2.888 0 00-2.887 2.886v5.773a2.888 2.888 0 002.887 2.887h7.075a2.888 2.888 0 002.887-2.887z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3308"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 690",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M148.101 200.769h8.515v7.36h-8.515z"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3034",
  d: "M47.906 48.644c4.344-9.109 14.458-32.635 21.86-40.774 7.5-8.244 148.691-10.2 159.7.486s21.581 39.2 21.581 39.2",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3309"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3035",
  d: "M58.018 48.644c3.946-7.167 13.146-25.675 19.871-32.081 6.816-6.485 135.166-8.026 145.177.383s19.618 30.84 19.618 30.84",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3036",
  d: "M130.032 11.009c1.553-4.561 2.229-6.879 4.045-7.14s31.16-.852 32.954.286 2.935 7.02 2.935 7.02",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3037",
  d: "M208.755 196.068l79.964 9.073 1.107-9.889-37-3.948",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3038",
  d: "M239.901 199.842c-.234 6.888.761 24.324 4.251 31.981a16.308 16.308 0 009.168 8.406c7.949 2.353 19.6 1.122 22.076-.752 2.995-2.265 5.044-4.228 6.622-9.63 1.589-5.438 2.57-15.682 2.967-25.018",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3039",
  d: "M285.147 194.573c-.017-2.962-.088-5.159-.271-6.928",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3310"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3040",
  d: "M61.577 198.129c.233 6.889.074 27.721-3.416 35.378a16.311 16.311 0 01-9.167 8.407c-7.949 2.353-19.6 1.122-22.076-.752-2.995-2.265-5.044-4.228-6.622-9.631-2.794-9.563-3.711-33.984-2.865-42.2",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3041",
  d: "M250.786 201.105c.137 8.48.648 15.766-1.566 19.786",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3311"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3042",
  d: "M51.345 193.618c-.136 8.479-.464 24.937 1.749 28.956",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3043",
  d: "M34.318 136.53c.384-30.385-2.961-63.339 4.807-67.872 16.053-9.367 219.885-8.263 223.48 3.535s4.828 48.672 3.6 68.066",
  fill: "none",
  stroke: "#aeb0b3",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

function SvgRearDistantGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304.054,
    height: 244.217,
    viewBox: "0 0 304 244"
  }, props), _ref);
}

export default SvgRearDistantGraphic;